import { APPLICATION_ROUTES, Endpoint, Route } from '@philips-emr/hpms-provider-accreditation-commons';
import { Value } from '@philips-emr/tws-core';
import { HttpService, MessageService } from '@philips-emr/tws-core/lib/services';
import HistoryService from '@philips-emr/tws-core/lib/services/history-service';
import { RequestResponse } from '@philips-emr/tws-core/lib/services/http-service';
import { applicationModuleRegistry, isApplicationModule } from '@philips-emr/tws-foundation';

class Audit {

  addRouteListener(): Function {
    return HistoryService.addListener((path: string) => this.routeChangeLog(path));
  }

  routeChangeLog(path: string): Promise<RequestResponse> {

    if (path.endsWith('/')) {
      path = path.slice(0, -1);
    }

    const routes: { [k: string]: string } = {
      [this.parseRoute(Route.MY_DATA)]: MessageService.translate('pa.my-data'),

      [this.parseRoute(APPLICATION_ROUTES.TECHNICAL_VISIT)]: MessageService.translate('pa.technical-visit'),
      [this.parseRoute(APPLICATION_ROUTES.TECHNICAL_VISIT_DETAILS)]: MessageService.translate('pa.technical-visit'),
      [this.parseRoute(Route.FORM_TECHNICAL_VISIT)]: MessageService.translate('pa.technical-visit'),
      [this.parseRoute(Route.TECHNICAL_VISIT_APPOINTMENTS)]: MessageService.translate('pa.technical-visit'),
      [this.parseRoute(Route.TECHNICAL_VISIT_FORMS)]: MessageService.translate('pa.technical-visit'),
      [this.parseRoute(Route.TECHNICAL_VISIT_INCONSISTENCIES)]: MessageService.translate('pa.technical-visit'),

      [this.parseRoute(APPLICATION_ROUTES.CALLS)]: MessageService.translate('pa.calls'),
      [this.parseRoute(Route.NEW_CALL)]: MessageService.translate('pa.calls'),
      [this.parseRoute(Route.NEW_USER_CONFIRMATION)]: MessageService.translate('pa.calls'),
      [this.parseRoute(Route.DETAILS_CALLED)]: MessageService.translate('pa.calls'),

      [this.parseRoute(APPLICATION_ROUTES.PROVIDER_ACCREDITATION)]: MessageService.translate('pa.accreditation'),
      [this.parseRoute(Route.ACCREDITATION)]: MessageService.translate('pa.accreditation'),
      [this.parseRoute(Route.NEW_PROVIDER_ACCREDITATION)]: MessageService.translate('pa.accreditation'),
      [this.parseRoute(Route.DETAIL_PROVIDER_ACCREDITATION)]: MessageService.translate('pa.accreditation'),
      [this.parseRoute(Route.TERM_PROVIDER_ACCREDITATION)]: MessageService.translate('pa.accreditation'),

      [this.parseRoute(Route.PRIVACY)]: MessageService.translate('pa.term'),
      [this.parseRoute(Route.ASSIGN_PRIVACY_WARNING)]: MessageService.translate('pa.term'),
      [this.parseRoute(Route.ASSIGN_TERM_USE)]: MessageService.translate('pa.term'),
      [this.parseRoute(Route.CHANGE_PW)]: MessageService.translate('pa.change-password'),
    };

    applicationModuleRegistry.getAll().forEach(module => {
      if (isApplicationModule(module)) {
        routes[this.parseRoute(module.route)] = MessageService.translate(module.name);
      }
    });

    const functionName = routes[this.parseCurrentRoute(path)];

    if (!functionName) {
      //@ts-ignore
      return Promise.resolve();
    }

    const body = {
      path,
      current: functionName,
    };

    return Audit.logAuditFunction(body);
  }

  static logAuditFunction(body: Record<string, Value>): Promise<RequestResponse> {
    return HttpService.post(Endpoint.POST.AUDIT_FUNCTION, {}, { body });
  }

  parseCurrentRoute(route: string): string {
    const regex = /\d+/g;
    return route.replace(regex, '');
  }

  parseRoute(route: string): string {
    const regex = /:\w+/g;
    return route.replace(regex, '');
  }

}

export default Audit;
